import type { ReactNode } from 'react'

export interface StatTileProps {
  label: ReactNode
  value: ReactNode
  detail?: ReactNode
  // Optional status line (e.g. a StatusChip) - the tile itself stays monochrome
  status?: ReactNode
}

// Monochrome KPI tile: color is reserved for status, so the number carries the weight
export function StatTile({ label, value, detail, status }: StatTileProps) {
  return (
    <div className="flex flex-col gap-1 rounded-xl border border-line bg-surface p-4">
      <span className="text-[13px] font-medium text-ink-secondary">{label}</span>
      <span className="font-heading text-[32px] font-bold leading-none tracking-[-0.02em] text-ink tabular-nums">{value}</span>
      {detail && <span className="text-xs text-muted">{detail}</span>}
      {status && <div className="mt-1">{status}</div>}
    </div>
  )
}
